// extracted by mini-css-extract-plugin
export default {"section_no_background":"studentStories_section_no_background__jXUUt"};